// @flow
import type { State } from '../redux/main';

const getPostSearchTrackingData = ({
  postSearch: { initialized, query, pageIndex, resultsByPage }
}: State) => {
  if (initialized) {
    const results = resultsByPage[pageIndex.toString()] || {};
    return {
      current_page: pageIndex + 1,
      search_query: query,
      number_of_results: results.nbHits,
      number_of_pages: results.nbPages
    };
  }
  return {};
};

export default getPostSearchTrackingData;
